import React from 'react'
import Image from 'components/image/image'
import './block-quote.sass'

const getImage = (images) => {
  if (images && images.length > 0) {
    return (
      <Image image_url={`avatars/${images[0]}`}
             className="BlockQuote__avatar mr-3"
             alt="Author profile avatar" />
    )
  }
}

const BlockQuote = ({ data }) => (
  <div className={`BlockQuote ${data.classes ? data.classes : ''} `}>
    <blockquote className="position-relative k-max-width--1">
      <div className="BlockQuote__content k-center-content">
        <div
          className="BlockQuote__quote"
          dangerouslySetInnerHTML={{ __html: data.titleContent }}
        />
        {data.content && (
          <cite
            className="
              d-flex
              align-items-center
              mt-4">
            {getImage(data.images)}
            <div
              className="BlockQuote__author"
              dangerouslySetInnerHTML={{ __html: data.content[0] }} />
          </cite>
        )}
      </div>
      <Image className="BlockQuote__icon"
             image_url="icons/icon-quotemark.svg"
             alt="Quotemark icon" />
    </blockquote>
  </div>
)

export default BlockQuote